import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  EmploymentDetails,
  ICreditScoreState,
  Person,
  ProveCSReq,
  QuestionData,
} from 'pages/creditScore/CreditScoreInterface';
import { Lead } from 'pages/leadGen/LeadGenInterface';
import {
  CreditScoreForProve,
  CreditScoreQuestions,
  CreditScoreSoftAssessment,
  EmployeeHistoryUrl,
  PublicLeadCreationOldUrl,
} from './ApiEndPoints';
import { handleApiError } from './CommonModuleState';

const initialState: ICreditScoreState = {
  creditScoreLoading: false,
  publicLeadCreationData: {},
  employeeHistoryData: {},
  // reportQuestions: {
  //   _id: '656466f384e0d871cd01df15',
  //   decision: 'Partial',
  //   questions: [
  //     {
  //       questionId: 1,
  //       questionText:
  //         'Your credit file indicates you may have a credit / store card which was opened approximately March 2024. Please choose the credit provider for this account.',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'O P P CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'LAKELAND CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'RADVILLE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'HUMBER VALLEY CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 2,
  //       questionText:
  //         'Your credit file indicates you may have an auto loan/lease which was opened approximately May 2023. Please choose the credit provider for this account from the following options',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'CYPRESS CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'DBA BARON AUTO GROUP',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'PORTAGE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'OMNI AUTO FINANCE INC.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 3,
  //       questionText:
  //         'Your credit file indicates you may have a line of credit which was opened approximately September 2021. Please choose the credit provider for this account from the following options. ',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'RAPPORT CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'PORTAGE CREDIT UNION LTD.',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'ICICI BANK',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'SYDNEY CREDIT UNION',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //     {
  //       questionId: 4,
  //       questionText:
  //         'Your credit file indicates you may have a telephone account which was opened approximately September 2020. Please choose the credit provider for this account.',
  //       choiceType: {
  //         type: 'SINGLE_CHOICE',
  //       },
  //       choices: [
  //         {
  //           choiceId: 1,
  //           choiceText: 'Sogetel',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 2,
  //           choiceText: 'SaskTel',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 3,
  //           choiceText: 'VIDEOTRON',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 4,
  //           choiceText: 'Eastlink',
  //           isCorrect: false,
  //         },
  //         {
  //           choiceId: 5,
  //           choiceText: 'None of the Above',
  //           isCorrect: true,
  //         },
  //       ],
  //     },
  //   ],
  // },

  reportQuestions: {
    _id: '',
    decision: '',
    questions: [],
  },
  reportError: '',
  softAssesmentData: {
    decision: '',
    errorMessage: '',
    creditScore: [],
    message: '',
  },
  creditScoreForProve: {
    message: '',
    success: false,
  },
};

export const postPublicLeadCreationOld = createAsyncThunk(
  'creditScore/leadCreationOld',
  async (data: { data: Lead; leadTypeID: string }) => {
    try {
      const response = await axios.post(`${PublicLeadCreationOldUrl}${data.leadTypeID}`, data.data);

      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const employeeHistory = createAsyncThunk('creditScore/employeeHistory', async (data: EmploymentDetails) => {
  try {
    const response = await axios.post(`${EmployeeHistoryUrl}${data?.leadId}`, data);

    return response.data;
  } catch (error: unknown) {
    const errorMessage = handleApiError(error);
    throw new Error(errorMessage);
  }
});

export const postQuestions = createAsyncThunk('creditScore/questions', async (data: { person: Person }) => {
  try {
    const response = await axios.post(CreditScoreQuestions, data);

    return response.data;
  } catch (error: unknown) {
    const errorMessage = handleApiError(error);
    throw new Error(errorMessage);
  }
});

export const softAssesment = createAsyncThunk('creditScore/softAssesment', async (data: QuestionData) => {
  try {
    const response = await axios.post(CreditScoreSoftAssessment, data);
    return response.data;
  } catch (error: unknown) {
    const errorMessage = handleApiError(error);
    throw new Error(errorMessage);
  }
});

export const getCreditScoreForProve = createAsyncThunk(
  'creditScore/getCreditScoreForProve',
  async (data: ProveCSReq) => {
    try {
      const response = await axios.post(CreditScoreForProve, data);

      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const creditScoreState = createSlice({
  name: 'creditScore',
  initialState,
  reducers: {
    clearLeadCreation: (state) => {
      return {
        ...state,
        publicLeadCreationData: initialState.publicLeadCreationData,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postPublicLeadCreationOld.pending, (state) => {
        state.creditScoreLoading = false;
      })
      .addCase(postPublicLeadCreationOld.fulfilled, (state, action) => {
        state.creditScoreLoading = false;
        state.publicLeadCreationData = action.payload;
      })
      .addCase(postPublicLeadCreationOld.rejected, (state, action) => {
        state.creditScoreLoading = false;
        state.publicLeadCreationData = {
          message: action.error.message,
          success: false,
        };
      })
      .addCase(employeeHistory.pending, (state) => {
        state.creditScoreLoading = true;
      })
      .addCase(employeeHistory.fulfilled, (state, action) => {
        state.creditScoreLoading = false;
        state.employeeHistoryData = action.payload;
      })
      .addCase(employeeHistory.rejected, (state, action) => {
        state.creditScoreLoading = false;
        state.employeeHistoryData = {
          message: action.error.message,
          success: false,
        };
      })
      .addCase(postQuestions.pending, (state) => {
        state.creditScoreLoading = true;
      })
      .addCase(postQuestions.fulfilled, (state, action) => {
        state.creditScoreLoading = false;
        // state.reportQuestions = state.reportQuestions;
        state.reportQuestions = action.payload.message;
      })
      .addCase(postQuestions.rejected, (state) => {
        state.creditScoreLoading = false;
        state.reportError = '';
      })
      .addCase(softAssesment.pending, (state) => {
        state.creditScoreLoading = true;
      })
      .addCase(softAssesment.fulfilled, (state, action) => {
        state.creditScoreLoading = false;
        state.softAssesmentData = action.payload.message;
      })
      .addCase(softAssesment.rejected, (state, action) => {
        state.creditScoreLoading = false;
        state.softAssesmentData = {
          message: action.error.message,
          success: false,
        };
      })
      .addCase(getCreditScoreForProve.pending, (state) => {
        state.creditScoreLoading = true;
      })
      .addCase(getCreditScoreForProve.fulfilled, (state, action) => {
        state.creditScoreLoading = false;
        state.softAssesmentData = action.payload.message;
      })
      .addCase(getCreditScoreForProve.rejected, (state, action) => {
        state.creditScoreLoading = false;
        state.softAssesmentData = {
          message: action.error.message,
          success: false,
        };
      });
  },
});

// Action creators are generated for each case reducer function
export const { clearLeadCreation } = creditScoreState.actions;
export default creditScoreState.reducer;
